import { onDomReady } from "./../../util/dom";

const HERO_VIDEO_SELECTOR = '.hero__video';
const HERO_VIDEO_LOADED_CLASS = 'hero__video--loaded';

onDomReady(() => {
    const heroVideo = document.querySelector(HERO_VIDEO_SELECTOR) as HTMLVideoElement | null;

    if (!heroVideo) {
        return;
    }

    const loadAndPlayVideo = () => {
        const source = heroVideo.querySelector('source');
        if (!source) {
            return;
        }

        const videoSrc = source.getAttribute('data-src');
        if (videoSrc) {
            source.setAttribute('src', videoSrc);

            heroVideo.load();

            heroVideo.addEventListener('canplaythrough', () => {
                heroVideo.play().catch(console.error);
                heroVideo.classList.add(HERO_VIDEO_LOADED_CLASS);
            }, { once: true });
        }
    };

    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    loadAndPlayVideo();
                    observer.disconnect();
                }
            });
        }, { threshold: 0.25 });

        observer.observe(heroVideo);
    } else {
        // if IntersectionObserver not supported, just play video
        loadAndPlayVideo();
    }
});

